var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1735870784556,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 2160,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M596 352m-208 0a208 208 0 1 0 416 0 208 208 0 1 0-416 0Z",
    fill: "#748FFC",
    "p-id": 2161
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80 500a282 281.76 90 1 0 563.52 0 282 281.76 90 1 0-563.52 0Z",
    fill: "#5C7CFA",
    "p-id": 2162
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M361.76 348.22H727.2A216.8 216.8 0 0 1 944 565.02v0.18A216.8 216.8 0 0 1 727.2 782H361.76V348.22z",
    fill: "#5C7CFA",
    "p-id": 2163
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M688.38 551.32c-0.4 34.8 2 42.94 1.5 70.2 0.28 42.28 0.68 77.08-6.46 111.42-10.4 50-37.4 90.78-74.36 126A316.14 316.14 0 0 1 520.42 918a18.34 18.34 0 0 1-16.68 0c-63.4-29.06-112.6-72.36-144.68-133.02-13.74-26-19.82-53.8-22.66-82.48-4.58-46.54-1.24-66.52-1.02-113.08 0-12.9 0.88-25.88 0.82-38.84 0-4.36 1.7-6.46 6-7.76q83.04-25.02 166-50.24a16 16 0 0 1 9.66 0.52q81.58 24.76 163.26 49.34c5 1.56 7.32 3.56 7.26 8.88z",
    fill: "#20C997",
    "p-id": 2164
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M512.16 879.38c-53.38-26.28-92-62.94-117.8-111.78-9.84-18.58-15.72-40.42-18.5-68.74-3.08-31.16-2.32-36-1.54-69.18 0.3-13.08 0.64-26.62 0.7-40 0-5.42 0.2-10.92 0.38-16.74 41.2-12.42 85.36-25.8 136.76-41.42 48.28 14.66 92.68 28.12 136.64 41.34 0.16 10.6 0.48 21 0.78 31.2 0.48 15.84 0.94 4.2 0.66 16.8v3.74c0.26 39.78 0.48 71.2-5.7 100.96-8 38.54-28.76 73.36-63.4 106.46a270 270 0 0 1-68.98 47.36z",
    fill: "#12B886",
    "p-id": 2165
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M486 746.92a14.94 14.94 0 0 1-10.58-4.36l-32.94-32.82a14.94 14.94 0 1 1 21.16-21.08L486 710.92l86-85.7a14.94 14.94 0 0 1 21.16 21.08l-96.56 96.24a14.94 14.94 0 0 1-10.6 4.38z",
    fill: "#FFFFFF",
    "p-id": 2166
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.a700820b44d711ba6dcb5f736475dbae.svg";
export { ForwardRef as ReactComponent };